'use strict';
import * as TASK_TYPES from '../../tasks/enums/TASK_TYPE';
import {getCreateChildErrorMessage} from '../utils';
import template from './milestones-create.html';
import {logger} from './logger';


export const modalOptions = {
  template,
  controller: MilestonesCreateController,
  animation: 'slide-in-up',
};

MilestonesCreateController.$inject = [
  '$modal',
  '$scope',
  '$miscUtils',
  'MilestoneDomain',
  '$toast',
  'milestone',
  'project',
  'taskType',
];

export const templates = [
  '$templateCache',
  CacheTemplates];

function CacheTemplates($templateCache) {
  $templateCache.put('projects/milestones-create.html', template);
}

export function MilestonesCreateController(
  $modal,
  $scope,
  $miscUtils,
  MilestoneDomain,
  $toast,
  existingMilestone,
  project,
  taskType,
) {
  const vm = $scope.milestonesCreate = initViewModel(existingMilestone);
  vm.save = $miscUtils.blockPromise(save);
  vm.cancel = !existingMilestone ?
    $modal.cancel.bind($modal) :
    function () {
      vm.model.$revert();
      $modal.cancel();
    };


  /*****************************************************************************************************************
   * Controller Actions
   ****************************************************************************************************************/

  function save() {
    if (!vm.model.$validate()) {
      logger.warn({errors: vm.model.$errors}, 'Validation failed');
      return Promise.reject(vm.model.$errors);
    }

    return (existingMilestone
      ? vm.model.update()
      : vm.model.create()
    )
      .then(newMilestone => {
        if (!existingMilestone) {
          $toast.showI18nMessage({messageId: 'milestones.create.success.message', type: 'info'});
        }
        if (newMilestone) {
          $modal.hide(newMilestone);
        } else {
          $modal.hide(vm.model);
        }
      }).catch(err => {
        logger.error({err});
        if (!existingMilestone) {
          showCreateErrorMessage(err);
        }
      });
  }

  function showCreateErrorMessage(error) {
    const messageId = getCreateChildErrorMessage(error && (error.statusCode || error.status));

    if (messageId) {
      $toast.showI18nMessage({
        messageId,
        i18nMessageParams: {child: 'projects.child.milestone_simple.label'},
        type: $toast.TOAST_TYPES.error,
      });
    }
  }


  /*****************************************************************************************************************
   * Presentation Logic
   ****************************************************************************************************************/


  /*****************************************************************************************************************
   * Load Data
   ****************************************************************************************************************/


  function initViewModel(milestone) {
    const vm = {};
    if (milestone) {
      vm.showWarning = false;
      vm.model = milestone;
      vm.header = 'milestones.edit.header.label';
    } else {
      vm.showWarning = taskType === TASK_TYPES.SITE;
      vm.model = MilestoneDomain.$factory.create();
      vm.model.project = project;
      vm.model.assetSpecific = taskType !== TASK_TYPES.PROJECT;
      vm.header = 'milestones.create.header.label';
    }
    return vm;
  }
}



// WEBPACK FOOTER //
// ./src/js/projects/modals/MilestonesCreateController.js